module.exports = __webpack_public_path__ + "img/img_platform01.eccf861a.jpg";